<template>
	<img class="heading-img" :src="imgUrl" :alt="altText" svg-inline />
</template>

<script>


export default {
	name: 'SceneHeading',
	props: {
		imgUrl: {
			type: String,
			required: true,
		},
		altText: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.heading-img {
		position: fixed;
		top: -10%;
		height: 30vh;
		min-height: 200px;
		max-height: unset;

		@include mobile {
			top: -12%;
			height: 30vh;
			min-height: 100px;
			max-height: 130px;
		}

		@include desktop { top: -10%; }
		@include desktop-sm { top: -15%; }
	}
</style>



// WEBPACK FOOTER //
// src/components/partials/SceneHeading.vue